import classNames from 'classnames';
import React, { memo } from 'react';

import { t } from '~/helpers/localization';

import PatrolsBundlesList from '~/pages/Patrols/containers/PatrolsBundlesList/PatrolsBundlesList';
import StepCSSTransitionGroup from '~/UIKit/StepCSSTransitionGroup/StepCSSTransitionGroup';

import styles from './PatrolsRules.module.scss';

const rules = [
  {
    header: t('About the Clan Patrols Event'),
    content: t(
      'The Clan Patrols event gives you an opportunity to receive bonuses and rewards by playing solo or in Divisions. You can obtain all the available rewards and bonuses until the end of Update (question).',
    ),
  },
  {
    header: t('How Clan Patrols Work'),
    content: t(
      "To start earning bonuses, simply select the battle type you want to play and join the Patrol. No specific actions are required from you in battle—just play as you normally would. Patrols are updated daily, and you'll be notified when they become available again.",
    ),
  },
  {
    header: t('How to Earn Bonuses and Rewards'),
    content: t(
      'You can join a Patrol either solo or in a Division. Playing solo will grant you extra bonuses, but teaming up with your Clanmates in a Division will earn you even more. Additionally, playing in a Division unlocks a reward track with four daily rewards. The more you play in Divisions, the better your chances of earning Rare rewards. Rewards can be refreshed daily, and if you refresh without claiming any, they’ll return to the reward pool.',
    ),
  },
  {
    header: t('Switching Clans'),
    content: t("If you switch Clans, any bonuses and rewards you've already earned will stay with you."),
  },
];

type IProps = {
  className?: string;
  animationLevelNested?: number;
};

const PatrolsRules: React.FC<IProps> = ({ className, animationLevelNested = 0 }) => {
  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.rules}>
        {rules.map((section, i) => {
          const rulesLevel = animationLevelNested + i * 2;
          return (
            <React.Fragment key={`rules_section${i}`}>
              <StepCSSTransitionGroup className={styles.header} level={rulesLevel + 1}>
                {section.header}
              </StepCSSTransitionGroup>
              <StepCSSTransitionGroup className={styles.rule} level={rulesLevel + 2}>
                {section.content}
              </StepCSSTransitionGroup>
            </React.Fragment>
          );
        })}
      </div>

      <StepCSSTransitionGroup className={styles.header} level={animationLevelNested + rules.length * 2 + 1}>
        {t('All possible bundles')}
      </StepCSSTransitionGroup>
      <PatrolsBundlesList animationLevel={animationLevelNested + rules.length * 2 + 2} />
    </div>
  );
};

export default memo(PatrolsRules);
